import SearchList from './SearchList';
import './style/search-list.less';

export default SearchList;
